export default __webpack_public_path__ + "static/media/deal-4.f287c1fe.webp";